<template>
  <div class="modules-settings-vendor-detail">
    <div
      class="nav-section"
      :class="{'no-border-top': !isContractor}"
    >
      <a
        class="nav-back"
        @click="navToVendorTab()"
      >
        {{ $t('back') }}
      </a>
    </div>
    <div class="company-info">
      <div
        v-if="!isContractor"
        class="vendor-number"
      >
        <label class="emphasis"> {{ $t('settings.user.vendor.number') }}: </label>
        <p>{{ companyInfo.id }}</p>
      </div>
      <label class="emphasis sub-title">{{ $t('settings.user.vendor.companyDetail') }}</label>
      <div class="row">
        <div class="small-6 medium-6 large-6 columns">
          <p>{{ (companyInfo || {}).name }}</p>
          <p>{{ (companyInfo || {}).address1 }}</p>
          <p>{{ (companyInfo || {}).address2 }}</p>
          <p>{{ (companyInfo || {}).address3 }}</p>
          <p>{{ (companyInfo || {}).address4 }}</p>
        </div>
        <div v-if="!isContractor">
          <input
            id="settings-users-contractor-company-name-update"
            v-model="specialHandled"
            v-hkldinput
            type="checkbox"
            :disabled="!editView"
            :class="{'disabled': !editView }"
          >
          <label for="settings-users-contractor-company-name-update">{{ $t('settings.user.vendor.combineName') }}</label>
        </div>
      </div>

      <label class="emphasis"> {{ $t('settings.user.vendor.phone') }}</label>
      <p>{{ (companyInfo || {}).phone | isEmptyValue }}</p>
    </div>
    <hr>
    <HKLCollapse
      :title="$t('userManagement.title')"
      :keepContentAlive="true"
      class="user-management"
    >
      <div
        slot="content"
        class="vendor-user-management"
      >
        <form
          id="vendor-detail-form"
          data-abide
          novalidate
          @submit.prevent
        >
          <div class="contract-detail">
            <TabsBar
              v-if="departmentNames.length > 0"
              :tabNames="departmentNames"
              :getCurrentTab="refreshCurrentContractorDetail"
              :disableSwitch="editView"
              :disabledTabs="[]"
            />
            <div
              class="invited-and-button row"
            >
              <div
                v-if="!isContractor && departmentNames.length > 0"
                class="login-invited-info columns"
              >
                <div class="last-login">
                  <span class="emphasis">{{ $t('lastLogin') }}: </span>
                  <span>{{ lastLoginAt | isEmptyValue }}</span>
                </div>
                <div class="invited-at">
                  <span class="emphasis">{{ $t('invitedAt') }}: </span>
                  <span>{{ invitedAt | isEmptyValue }}</span>
                </div>
              </div>

              <div
                v-if="showButtons"
                class="columns"
              >
                <div class="row action-bar">
                  <HKLButton
                    v-if="!isContractor && !editView"
                    color="darkblue"
                    action="sendInvitation"
                    @click="sendInvitation()"
                  />
                  <HKLButton
                    v-if="!editView"
                    color="orange"
                    action="edit"
                    @click="editView = true"
                  />
                  <HKLButton
                    v-if="editView"
                    v-hkldreset
                    color="darkblue"
                    action="cancel"
                    @click="discardChange()"
                  />
                  <HKLButton
                    v-if="editView"
                    v-hkldreset
                    color="orange"
                    action="save"
                    @click="save()"
                  />
                </div>
              </div>
            </div>
            <label class="emphasis sub-title"> {{ $t('settings.user.vendor.adminDetail') }}</label>
            <div
              v-if="!isContractor"
              class="row"
            >
              <div class="small-4 medium-4 large-4 columns">
                <label class="emphasis"> {{ $t('settings.user.vendor.userType') }}</label>
                <p>{{ $t('userType.contractorAdmin') }}</p>
              </div>
              <div>
                <label
                  class="emphasis"
                  :class="{ 'required-flag': editView }"
                >
                  {{ $t('settings.user.vendor.userStatus') }}
                </label>
                <HKLSelect
                  v-show="editView"
                  id="settings-users-contractor-detail-multiselect"
                  :value="status"
                  :class="vendorStatusErrClass"
                  style="width: 200px;"
                  :options="statusHklOptions"
                  :showSearch="false"
                  placeholder=""
                  @change="val => { status = val; validate() }"
                />
                <p v-show="!editView">
                  {{ status }}
                </p>
              </div>
            </div>

            <div class="row">
              <div class="small-4 medium-4 large-4 columns">
                <label
                  class="emphasis"
                  :class="{ 'required-flag': editView }"
                >
                  {{ $t('settings.user.vendor.contactAdminName') }}
                </label>
                <HKLInput
                  v-show="editView"
                  v-model="contactAdminName"
                  v-hkldinput
                  v-fusioninputcheck="{
                    type: 'string',
                    required: true,
                  }"
                  class="hkl-input-with-95"
                  type="text"
                  required
                  @change="validate"
                />
                <p v-show="!editView">
                  {{ contactAdminName }}
                </p>
              </div>
              <div v-if="enableWorkPermitsFeature">
                <label
                  class="emphasis"
                  :class="{ 'required-flag': editView }"
                >
                  {{ $t('settings.user.vendor.swpVendors') }}
                </label>
                <HKLSelect
                  v-show="editView"
                  id="settings-users-contractor-detail-multiselect-swp"
                  style="width: 200px;"
                  :value="swpEnabled"
                  :options="swpHklOptions"
                  :showSearch="false"
                  placeholder=""
                  @change="updateSwpPerms"
                />
                <p v-show="!editView">
                  {{ formatBooleanValue(swpEnabled) }}
                </p>
              </div>
            </div>

            <div>
              <label
                class="emphasis"
                :class="{ 'required-flag': editView }"
              >
                {{ $t('settings.user.vendor.phone') }}
              </label>
              <input
                v-show="editView"
                v-model="contactPhoneNum"
                v-hkldinput
                v-fusioninputcheck="{
                  type: 'string',
                  pattern: regex.phone,
                  tip: tips.phone
                }"
                type="text"
                required
                @change="validate"
              >
              <p v-show="!editView">
                {{ contactPhoneNum }}
              </p>
            </div>

            <div v-if="!isContractor">
              <label
                class="emphasis"
                :class="{ 'required-flag': editView }"
              >
                {{ $t('username') }}
              </label>
              <HKLInput
                v-show="editView"
                v-model="username"
                v-hkldinput
                v-fusioninputcheck="{
                  type: 'string',
                  tip: usernameTip,
                  pattern: validateUsername,
                  required: true
                }"
                class="hkl-input-with-95"
                :class="usernameErrClass"
                type="text"
                pattern="email"
                required
                @change="validate"
              />
              <p v-show="!editView">
                {{ username }}
              </p>
            </div>
            <div v-if="!isContractor">
              <label
                class="emphasis"
                :class="{ 'required-flag': editView }"
              >
                {{ $t('settings.user.vendor.email') }}
              </label>
              <HKLInput
                v-show="editView"
                v-model="emailAddress"
                v-hkldinput
                v-fusioninputcheck="{
                  type: 'string',
                  required: true
                }"
                class="hkl-input-with-95"
                type="text"
                pattern="email"
                required
                @change="validate"
              />
              <p v-show="!editView">
                {{ emailAddress }}
              </p>
            </div>
            <div v-else>
              <div class="reset-password">
                <label class="emphasis"> {{ $t('settings.user.vendor.loginEmail') }}</label>
                <p class="inline-text">
                  {{ username }}
                </p>
              </div>
              <HKLButton
                v-if="isContractorAdmin"
                class="reset-link"
                action="reset-link"
                color="orange"
                @click="navToResetPwd()"
              >
                {{ $i18n.t('settings.password.resetYourPassword') }}
              </HKLButton>
            </div>
          </div>
        </form>
        <hr>
        <VendorSubAccounts ref="vendorSubAccounts" />
      </div>
    </HKLCollapse>
    <VendorContacts />
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { computed, ref, unref, getCurrentInstance } from 'vue-demi'
import HKLButton from '@/controls/Button/HKLButton'
import HKLCollapse from '@/controls/Collapse'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import TabsBar from '@/controls/TabsBar'
import * as accountsRequest from '@/api/accounts/request'
import { getDepartments } from '@/api/departments/request'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { aclHelper, aclPermsType, Rcs } from '@/utils/aclHelper'
import { EmailTypes } from '@/utils/consts'
import dateUtil from '@/utils/dateUtil'
import EventBus from '@/utils/eventBus'
import notification from '@/utils/notification'
import * as regex from '@/utils/regex'
import HKLInput from '@/controls/Input/HKLInput.vue'
import VendorSubAccounts from './VendorSubAccounts'
import VendorContacts from './VendorContacts'
import { ContractorSubAccPermsMap } from './consts'
import { useValidateInternalUsername } from './hook'

export default {
  name: 'VendorDetail',
  components: {
    HKLInput,
    HKLButton,
    HKLCollapse,
    HKLSelect,
    TabsBar,
    VendorSubAccounts,
    VendorContacts,
  },
  provide: function () {
    return {
      getAccountInfo: () => this.accountInfo,
      getSwpEnabled: () => this.swpEnabled,
      getActiveDepartmentId: () => this.activeDepartmentId,
      getCompanyInfo: () => this.companyInfo,
    }
  },
  props: {
    contactId: {
      type: String,
      default: '',
    },
  },
  setup () {
    const { proxy: that } = getCurrentInstance()
    const status = ref('')
    const username = ref('')
    const isInvalidEmail = ref(false)
    const validateEmailIfProjectRep = async () => {
      const result = await accountsRequest.checkIfProjectRep(
        that.accountInfo.vendorId, unref(username), true,
      )
      isInvalidEmail.value = result
      return result
    }
    const restStatus = () => {
      isInvalidEmail.value = false
    }
    const { validateUsername, usernameTip } = useValidateInternalUsername()
    return {
      username,
      status,
      vendorStatusErrClass: computed(() => {
        return { 'error-highlight': !unref(status) }
      }),
      usernameErrClass: computed(() => {
        return { 'is-invalid-input': unref(isInvalidEmail) }
      }),
      usernameTip,
      validateUsername,
      validateEmailIfProjectRep,
      restStatus,
    }
  },
  data () {
    const options = ['Active', 'Inactive']
    const swpOptions = [
      { label: 'Yes', value: true },
      { label: 'No', value: false },
    ]
    const tips = {
      phone: this.$i18n.t('hint.inputTip.phone'),
    }
    return {
      allContractorDetails: [],
      contractorDetail: {},
      editView: false,
      options,
      swpEnabled: false,
      swpOptions,
      aclHelper,
      accountInfo: {},
      companyAddress: {},
      admin: null,
      contactAdminName: '',
      emailAddress: '',
      invitedAt: '',
      lastLoginAt: '',
      contactPhoneNum: '',
      companyPhoneNum: '',
      ADDRESS: 'ADDRESS',
      NAME: 'NAME',
      EMAIL: 'EMAIL',
      PHONE_NUMBER: 'PHONE_NUMBER',
      sendInvitationEnabled: false,
      regex,
      tips,
      specialHandled: false,
      departments: [],
      activeDepartmentId: null,
      companyInfo: {},
      currentActiveIndex: 0,
    }
  },
  computed: {
    ...mapGetters('user', ['currentUser', 'isEngineer', 'isContractor', 'isContractorAdmin', 'isAdmin']),
    ...mapGetters('regions', [
      'enableTenderFeature',
      'enableProjectFeature',
      'enableWorkPermitsFeature',
    ]),
    showButtons () {
      return this.isEngineer && this.hasSettingsUpdateAccess && this.allowedContractorDetails.length > 0
    },
    hasSettingsUpdateAccess () {
      return aclHelper.getSettingsUpdateAccess()
    },
    hasReadVendorsAccess () {
      return aclHelper.getAccess(aclPermsType.settings.readVendors)
    },
    allowedDepartmentIds () {
      let result = this.currentUser.departments || []
      if (this.isEngineer && !this.isAdmin && !this.hasSettingsUpdateAccess) {
        result = this.currentUser.departments.filter(item => {
          const isDepartmentAdmin = lodash.get(item, 'UserDepartment.isAdmin', false)
          return isDepartmentAdmin || this.hasReadVendorsAccess
        })
      }
      return result.map(({id}) => id)
    },
    allowedContractorDetails () {
      if (this.isAdmin || this.hasSettingsUpdateAccess) return this.allContractorDetails
      return this.allContractorDetails.filter(({ departmentId }) => {
        return this.allowedDepartmentIds.includes(departmentId)
      })
    },
    departmentNames () {
      let result = []
      if (this.allowedContractorDetails.length > 0) {
        result = this.allowedContractorDetails.map((detail) => {
          const departmentId = lodash.get(detail, ['departmentId'])
          const departmentInfo = this.departments.find((department) => {
            const id = lodash.get(department, ['id'])
            return lodash.isEqual(id, departmentId)
          })
          const name = lodash.get(departmentInfo, ['name'])
          return name
        })
      }
      return result.filter(item => !lodash.isEmpty(item))
    },
    statusHklOptions () {
      return this.options.map((value) => ({
        name: this.customStatusLabel(value),
        value,
      }))
    },
    swpHklOptions () {
      return this.swpOptions.map((option) => ({
        name: this.$t(`action.${option.label.toLowerCase()}`),
        value: option.value,
      }))
    },
  },
  async mounted () {
    await this.initPage()
  },
  destroyed () {
    if (this.contractorDetailAbide) {
      this.contractorDetailAbide.destroy()
    }
  },
  methods: {
    ...mapActions('user', ['loadContact']),
    customStatusLabel (option) {
      return this.$t(`status.${option.toLowerCase()}`)
    },
    filterContact (contacts, code, index = 0) {
      if (contacts instanceof Array) {
        return ((contacts.filter(contact => contact.type === code))[index] || {}).value
      }
      return []
    },
    setContact (contacts = [], code, value, index = 0) {
      const existedRecord = (contacts.filter(contact => contact.type === code))[index]
      if (existedRecord) {
        existedRecord.value = value
      } else {
        value && contacts.push({
          value,
          type: code,
        })
      }
    },

    getAdminUser (users = []) {
      const admin = users.find(user => user.primary)
      return admin || {}
    },

    formatBooleanValue (value) {
      return value ? this.$t('action.yes') : this.$t('action.no')
    },

    updateSwpPerms (value) {
      const permType = Rcs.StandaloneWorkPermits
      this.swpEnabled = value
      if (value) {
        this.admin.perms[permType] = ContractorSubAccPermsMap[permType]
      } else {
        delete this.admin.perms[permType]
      }
    },

    setPageModels () {
      if (this.contractorDetail) {
        this.accountInfo = {
          vendorId: this.contractorDetail.id,
          name: this.contractorDetail.name,
          specialHandled: this.contractorDetail.specialHandled || false,
        }
        this.specialHandled = this.accountInfo.specialHandled
        if (this.contractorDetail.users.length) {
          this.admin = this.getAdminUser(this.contractorDetail.users)
          const contacts = this.admin.contacts
          this.username = this.admin.username
          this.invitedAt = dateUtil.formatDate(this.admin.invitedAt, true)
          this.lastLoginAt = dateUtil.formatDate(this.admin.lastLoginAt, true)
          if (contacts) {
            this.companyAddress = this.filterContact(contacts, this.ADDRESS)
            this.contactAdminName = this.filterContact(contacts, this.NAME)
            this.emailAddress = this.filterContact(contacts, this.EMAIL)
            this.contactPhoneNum = this.filterContact(contacts, this.PHONE_NUMBER)
            this.companyPhoneNum = this.filterContact(contacts, this.PHONE_NUMBER, 1)
          }
        }
      }
    },
    discardChange () {
      fusionInputCheckUtil.resetAllFields()
      this.contractorDetail = this.keep
      this.setPageModels()
      this.setUserStatus()
      this.editView = false
      this.restStatus()
    },

    async initPage () {
      // TODO <sam_liang@epam.com> Refactor the data function of the compoenent
      // There are too many unnecessary property in the data function
      const id = this.contactId || this.$router.currentRoute.params.id
      const getAccount = accountsRequest.getAccountById(id)
      const getAllDepartments = getDepartments()
      try {
        const [
          {
            company: companyInfo,
            groupAccounts: repondContractorDetails,
          },
          repondDepartments,
        ] = await Promise.all([getAccount, getAllDepartments])
        this.departments = repondDepartments
        this.companyInfo = companyInfo
        const sortedContractorDetails = lodash.sortBy(repondContractorDetails, ({ departmentId }) => {
          const department = lodash.find(repondDepartments, ({ id }) => id === departmentId)
          const departmentName = lodash.get(department, ['name'])
          return departmentName
        })
        this.allContractorDetails = sortedContractorDetails
      } catch (error) {
        console.error('VendorDetail request error', error)
      }
    },
    validate () {
      fusionInputCheckUtil.validateAllFields()
      return this.status &&
        ($('#vendor-detail-form input.is-invalid-input').length === 0) &&
        fusionInputCheckUtil.isAllFieldsValid('#vendor-detail-form')
    },
    setUserStatus () {
      if (!this.contractorDetail || !this.admin) return
      this.userid = this.admin.id
      this.status = this.admin.enabled ? this.options[0] : this.options[1]
      this.sendInvitationEnabled = !this.admin.password
      this.swpEnabled = !!lodash.get(this.admin, 'perms.StandaloneWorkPermits', false)
    },
    async save () {
      const isProjectRep = await this.validateEmailIfProjectRep()
      // the validate method is used on input boxes
      const isValid = this.validate()
      if (!isValid || isProjectRep) return

      if (this.specialHandled !== this.accountInfo.specialHandled) {
        await accountsRequest.handleSpecialName(this.accountInfo.vendorId, this.contractorDetail.type, this.specialHandled)
      }
      if (this.contractorDetail && this.contractorDetail.id) {
        await this.updateContact()
        this.keep = lodash.cloneDeep(this.contractorDetail)
      }
      this.editView = false
      await this.initPage()
      EventBus.emit('refresh:vendor-sub-accounts')
      this.refreshCurrentContractorDetail(this.currentActiveIndex)
    },
    async updateContact () {
      const contractorDetail = lodash.cloneDeep(this.contractorDetail)
      const adminUser = (contractorDetail.users || []).find(user => user.primary)
      adminUser.enabled = (this.status === this.options[0])
      adminUser.username = this.username
      contractorDetail.username = this.username
      const contacts = adminUser.contacts
      if (contacts) {
        this.setContact(contacts, this.ADDRESS, this.companyAddress)
        this.setContact(contacts, this.NAME, this.contactAdminName)
        this.setContact(contacts, this.EMAIL, this.emailAddress)
        this.setContact(contacts, this.PHONE_NUMBER, this.contactPhoneNum)
        this.setContact(contacts, this.PHONE_NUMBER, this.companyPhoneNum, 1)
      }
      const permType = Rcs.StandaloneWorkPermits
      if (!this.swpEnabled) {
        contractorDetail.users.forEach(account => {
          delete account.perms[permType]
        })
      }

      await accountsRequest.updateAccountAdminDetail(this.contractorDetail.id, contractorDetail)
      if (this.isContractor) {
        await this.loadContact({ externalId: this.contractorDetail.id })
      }
    },

    async sendInvitation () {
      if (this.status === this.options[1]) {
        notification.fireNotification(false, this.$t('error.inviteCreatedContractor.mustEnableUser'))
        return
      }

      const metaData = {
        id: this.userid,
        name: (this.contractorDetail || {}).name,
        adminContact: this.contactAdminName,
        template: EmailTypes.settings.createPassword,
        departmentId: this.activeDepartmentId,
      }

      const data = await accountsRequest.inviteAccount(this.userid, metaData, 'inviteCreatedContractor')
      this.invitedAt = dateUtil.formatDate(data.invitedAt, true)
    },

    navToResetPwd () {
      this.$router.push({
        name: 'resetContractorPwd',
      })
    },
    navToVendorTab () {
      const from = this.$router.currentRoute.params.navFrom
      if (from === 'allVendors') {
        this.$router.push({
          name: 'all-contractors',
        })
      } else {
        this.$router.goBack()
        EventBus.emit('active-user-tab', 'contractor')
      }
    },
    refreshCurrentContractorDetail (index) {
      if (this.currentActiveIndex !== index) {
        this.currentActiveIndex = index
      }
      this.contractorDetail = this.allowedContractorDetails[index]
      this.activeDepartmentId = lodash.get(this.allowedContractorDetails[index], ['departmentId'], null)
      this.keep = lodash.cloneDeep(this.contractorDetail)
      this.setPageModels()
      this.setUserStatus()
      this.restStatus()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';

.modules-settings-vendor-detail {
  padding: 0 24px;
  ::v-deep .collapse {
    .content {
      border: none
    }
  }
  #vendor-detail-form {
    margin-top: 10px;
  }
  .company-info {
    margin-top: 10px;
  }
  & ::v-deep .tabsbar-title {
    border: none
  }
  .invited-and-button {
    margin: 10px 0;
  }
  .action-bar {
    justify-content: flex-end;
    button {
      margin-left: 10px;
    }
  }
  .user-management {
    margin-bottom: 10px;
  }
}

.contract-detail {
  padding-bottom: 24px;
  label {
    margin-top: 8px;
    margin-bottom: 0;
  }
  input {
    margin-bottom: 10px;
  }
}

.disabled, .disabled + label[for] {
  cursor: default;
}

.nav-section{
  padding: 10px 0;
  border-bottom: 1px solid #e0e0e0;
  a {
    padding-left: 0;
    font-size: 14px;
  }
}

.nav-section.no-border-top {
  padding-top: 0;
}

#settings-users-contractor-detail-fullname {
  font-weight: bold;
  margin: 1vh 20px;
}

#settings-users-contractor-detail-multiselect {
  margin: 0 0 1vh 0;
}

.vendor-number {
  a {
    padding-left: 0;
    color:#1779ba;
    text-decoration: underline;
  }
  label {
    margin-top: 0;
  }
}
.reset-password {
  float: left;
  margin-bottom:15px;
}
.reset-link {
  margin-top: 18px;
  margin-left:15px;
}

.inline-text {
  display: inline;
}
</style>

<style lang="scss">
.modules-settings-vendor-detail{
  .error-highlight .multiselect__tags,
  .error-highlight .multiselect__input,
  .error-highlight .multiselect__single {
    background-color: #f9ecea;
  }

  input[type='text']:focus {
    box-shadow: none;
  }

  .multiselect__tags, .multiselect__input {
    border: none;
  }
  #addSubAccModal {
    .error-highlight {
      background-color: #f9ecea;
    }
  }
}
</style>
